import { render } from "./FormDataTable.vue?vue&type=template&id=5fa7d2b4&scoped=true"
import script from "./FormDataTable.vue?vue&type=script&lang=js"
export * from "./FormDataTable.vue?vue&type=script&lang=js"

import "./FormDataTable.vue?vue&type=style&index=0&id=5fa7d2b4&scoped=true&lang=css"

import exportComponent from "/builds/uf-manage/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa7d2b4"]])

export default __exports__